import styled from 'styled-components/native';
import style from '../../../styles/index';

export const ItemsContainer = styled.ScrollView`
  background: ${style.colors.white};
  flex: 1;
`;

export const Container = styled.View`
  background: ${style.colors.white};
  flex: 1;
  padding: 20px;
`;

export const HeaderCart = styled.View`
  background: ${style.colors.white};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  margin-bottom: 20px;
`;

export const Title = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.large};
`;

export const ButtonContainer = styled.View``;

export const TotalContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const TotalTitle = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
`;

export const TotalPrice = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
`;

export const ConfirmContainer = styled.View`
  padding: 32px;
  background-color: #fff;
  border-radius: 24px;
  shadow-color: #000;
  shadow-offset: 0px 10px;
  shadow-opacity: 0.15;
  shadow-radius: 30px;
  elevation: 10;
  width: 100%;
`;

export const InputTextContainer = styled.View`
  margin-bottom: 20px;
  width: 100%;
`;

export const Label = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: 16px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
`;

export const InputText = styled.TextInput`
  color: #333;
  font-family: ${style.fontName.ubuntuRegular};
  font-size: 16px;
  padding: 16px;
  border-width: 1px;
  border-color: #E0E0E0;
  border-radius: 12px;
  background-color: #F7F7F9;
  width: 100%;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 8px;
  background-color: #F2F2F2;
  border-radius: 50px;
  z-index: 10;
`;
